import { observer } from 'mobx-react-lite';
import { Outlet, useParams } from 'react-router';
import { Box } from '@mui/material';
import { useStore } from '../../../hooks/useStore';
import { ActiveBudget } from '../dashboard/widgets/activeBudget';
import { useEffect } from 'react';
import { format } from 'date-fns';
import { useDate } from '../partials/profilePagesPartial';

export const EmployeeBenefitsPage = observer(() => {
  const { employeeStore } = useStore();
  const { employeeId } = useParams();
  const [date, setDate] = useDate();

  useEffect(() => {
    const fn = async () => {
      if (date && employeeId) {
        return employeeStore.fetchEmployeeBudgetInformation(employeeId, format(date, 'yyyy-MM-dd'));
      }
    };
    fn();
  }, [date]);

  return (
    <Box
      sx={{
        minHeight: '100%',
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gridTemplateRows: 'min-content 1fr',
        gridGap: '1.5rem 2rem',
        '& > div:last-of-type': {
          gridColumn: '1 / 3'
        }
      }}
    >
      <ActiveBudget
        total_available_amount={
          employeeStore.currentEmployee?.benefit_budget?.total_available_amount ?? 0
        }
        total_used_amount={employeeStore.currentEmployee?.benefit_budget?.total_used_amount ?? 0}
        initialDate={date}
      />
      <Box paddingBottom={4} marginBottom={-4}>
        <Outlet context={{ date: [date, setDate] }} />
      </Box>
    </Box>
  );
});
